module.exports = __webpack_public_path__ + "img/orangesmiley.73cfb4d6.png";